export const ZERO_STATUS = 0;
export const ONE_STATUS = 1;

export const USE_GET_LIST_USER = 'use_get_list_user';

export const ALL_STATUS = -1;
export const ACTIVE_STATUS = 1;
export const INACTIVE_STATUS = 0;
